import { cn } from "@/lib/utils"
import { Link } from "react-router"

export interface HashSidebarItemType {
  label?: string
  icon?: any
  activeIcon?: any
  to?: string

  dark?: boolean
  active?: boolean
  baseHash?: string
}

function HashSidebarItem(props: HashSidebarItemType) {
  return (
    <Link
      to={{
        hash: `${props.baseHash}/${props.to}`,
      }}
      className={cn(
        `group flex h-10 items-center gap-3 truncate rounded-xl px-4 text-sm leading-5 font-medium hover:bg-card-hover hover:text-card-foreground`,
        props.active && "bg-card-hover",
      )}
    >
      {props.icon && <i className={cn("size-5 text-secondary group-hover:text-foreground", props.active && "text-foreground")}>{props.icon}</i>}
      {props.label}
    </Link>
  )
}

export default HashSidebarItem
